import React from "react";
import { Grid, Skeleton } from "@mui/material";
import styles from "./Dashboard.module.scss";

/*
 * Loading state for the dashboard.
 *
 * A skeleton rather than a spinner: it occupies the same layout the real
 * content will, so the page does not jump when data arrives, and it reads as
 * "this is loading" instead of "this is empty". Every block mirrors the real
 * section it stands in for — five tiles, four tiles, three charts, two tables.
 */

const SectionHead = ({ width }) => (
	<div className={styles.sectionHead}>
		<Skeleton variant="text" width={width} height={18} />
		<span className={styles.sectionRule} />
	</div>
);

const TileSkeleton = () => (
	<Skeleton variant="rounded" height={132} sx={{ borderRadius: "6px" }} animation="wave" />
);

const CardSkeleton = ({ height }) => (
	<Skeleton variant="rounded" height={height} sx={{ borderRadius: "10px" }} animation="wave" />
);

const DashboardSkeleton = () => (
	<div className={styles.page}>
		<div className={styles.pageHead}>
			<Skeleton variant="text" width={230} height={30} />
			<Skeleton variant="text" width={180} height={20} />
		</div>

		<SectionHead width={60} />
		<Grid container spacing={2}>
			{[0, 1, 2, 3, 4].map((i) => (
				<Grid item xs={12} sm={6} md={4} lg={2.4} key={i}>
					<TileSkeleton />
				</Grid>
			))}
		</Grid>

		<SectionHead width={140} />
		<Grid container spacing={2}>
			{[0, 1, 2, 3].map((i) => (
				<Grid item xs={12} sm={6} md={3} key={i}>
					<TileSkeleton />
				</Grid>
			))}
		</Grid>

		<SectionHead width={70} />
		<Grid container spacing={2}>
			<Grid item xs={12} lg={8}>
				<CardSkeleton height={330} />
			</Grid>
			<Grid item xs={12} lg={4}>
				<CardSkeleton height={330} />
			</Grid>
			<Grid item xs={12}>
				<CardSkeleton height={330} />
			</Grid>
		</Grid>

		<SectionHead width={150} />
		<Grid container spacing={2}>
			<Grid item xs={12} md={6}>
				<CardSkeleton height={300} />
			</Grid>
			<Grid item xs={12} md={6}>
				<CardSkeleton height={300} />
			</Grid>
		</Grid>

		<SectionHead width={150} />
		<CardSkeleton height={260} />
	</div>
);

export default DashboardSkeleton;
